import React, { useContext, useEffect } from 'react';
import { QuestionToAsk, PrintPage } from '../../components';
import userContext from '../../components/ContextComponent/UserContext';
import { AmazonCardOption } from '../../utils/AmazonPixel';
import { CallMetaPixelEvent } from '../../utils/MetaPixel';
import { CallIMOOnThankYouPage } from '../../utils/IMOPixel';
import { CallCriteoOnThankYouPage } from '../../utils/CriteoPixel';
import { CallTaboolaOnThankYouPage } from '../../utils/TaboolaPixel';
import { CallThinkResultOnThankYouPage } from '../../utils/ThinkResultPixel';
import { LinkedInEvent } from '../../utils/LinkedInPixel';

function GO2Approved({ apiOutput, data }) {
    const { formData } = useContext(userContext);

    useEffect(() => {
        CallIMOOnThankYouPage();
        CallCriteoOnThankYouPage();
        CallMetaPixelEvent();
        CallTaboolaOnThankYouPage();
        CallThinkResultOnThankYouPage();
        window.setITag("confirmation", "success", "23644");
        window.setPageContext("ThankYou");
    }, []);
    return (
        <div>
            <div className="stack body">
                <div className="pad-responsive">
                    <div className="text-align-center pad-1">
                        Thank you {formData.firstName}!
                    </div>
                    <div className="text-align-center pad-1">
                        We have received your application and now need to verify your identity.
                    </div>
                    <div className="text-align-center pad-1">
                        Application Reference No. {apiOutput.go2ApiPcnNumber}
                    </div>
                    <div></div>
                    {/*<div className="text-align-center pad-1">*/}
                    {/*    Please follow on the link below to complete your identify verification process through Video KYC.*/}
                    {/*</div>*/}
                </div>
                <div className="pad-4">
                    {/*<div className="flex flex-column flex-align-items-center pad-responsive">*/}
                    {/*    <a href={formData.IdFyCaptureUrl}>*/}
                    {/*        <Button styleType="primary">Start your Video KYC</Button>*/}
                    {/*    </a>*/}
                    {/*</div>*/}
                    <PrintPage />
                    <QuestionToAsk />
                </div>
            </div>
            <img src="https://www.facebook.com/tr?id=333035019537250&ev=Lead" height="1" width="1" style={{ display: 'none' }} />
            <AmazonCardOption product={data?.selectedProduct} />
            <LinkedInEvent />
        </div>
    );
}
export default GO2Approved;